import React, { Component, useRef, useState } from "react";
import {
    DataGrid,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup as dxLookup
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label, GroupItem, } from "devextreme-react/form";
import { Button, DateBox, Lookup, NumberBox, SelectBox } from "devextreme-react";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarParametrosPixDs } from "../../DataSources";
import showReport from "../../showReport";
import UserInfo from "../../UserInfo";

const AlvarasEmitidos = (props) => {
    const { onSelecionado, usadoComoPesquisa } = props;

    let _formInstance = useRef();

    const [exercicio, setExercicio] = useState()
    const [dataEmissaoInicial, setDataEmissaoInicial] = useState(undefined)
    const [dataEmissaoFinal, setdataEmissaoFinal] = useState(undefined)
    const [statusAlvara, setStatusAlvara] = useState(undefined)
    const [tipo, settiposAlvara] = useState(undefined)


    const testeStatus = (e) => {
        alert(e.value)
    }

    const tagOptions = {
        editorType: "dxTagBox",
        selectionMode: "multiple",
        searchEnabled: false,
        placeholder: "Escolher...",
        dataSource: [
            { id: 1, descricao: "Funcionamento", tipo: "TLLF" },
            { id: 2, descricao: "Transporte", tipo: "TLTA" },
            { id: 3, descricao: "Sanitário", tipo: "TLAS" },
            { id: 4, descricao: "Horário Especial", tipo: "TLFHE" },
            { id: 5, descricao: "Publicidade", tipo: "TLVP" },
            { id: 6, descricao: "Uso Log. Público", tipo: "TLULP" },
            { id: 7, descricao: "Diversos", tipo: "TLAD" },
        ],
        valueExpr: "tipo",
        displayExpr: "descricao",
        showClearButton: true,
        value: tipo,
        onValueChanged: (e) => settiposAlvara(e.value)
    };

    const statusOptions = {
        editorType: "dxTagBox",
        selectionMode: "multiple",
        searchEnabled: false,
        placeholder: "Escolher...",
        dataSource: [
            { id: 0, descricao: "Gerado" },
            { id: 1, descricao: "Pago ou Dispensado" },
            { id: 2, descricao: "Emitido" },
            { id: 3, descricao: "Cancelado" },
            { id: 4, descricao: "Suspenso" },
            { id: 5, descricao: "Cassado" },
            { id: 6, descricao: "Excluído" }],
        valueExpr: "id",
        displayExpr: "descricao",
        value: statusAlvara,
        onValueChanged: (e) => setStatusAlvara(e.value)

    };

    const imprimir = () => {
        const filter = { exercicio, dataEmissaoInicial, dataEmissaoFinal, statusAlvara, tipo }
        showReport(`/report/alvaras_emitidos/${UserInfo.getPrefeitura()}`, filter);
    }

    const limparFiltro = () => {
        if (_formInstance && _formInstance.instance) {
            _formInstance.instance.repaint();
        }

        console.log("limpar filtro");
    }


    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <form onSubmit={imprimir}>
                    <Form id="frmPesquisa" colCount={2}
                        ref={(e) => (_formInstance = e)}>
                        <GroupItem colCount={3} colSpan={2} caption="RELATÓRIO DE ALVARÁS EMITIDOS">
                            <SimpleItem
                                value={exercicio}
                                colSpan={2}
                                editorType={"dxTextBox"}
                                editorOptions={{value:exercicio, onValueChanged:(e) => setExercicio(e.value), placeholder:"Exercícios separados por vírgula. Ex: (2021, 2022,2023...)"}}
                            >
                                <Label text="Exercício" />        
                            </SimpleItem>
                            <SimpleItem colSpan={2}>
                                <Label text="Data de Emissão Inicial" />
                                <DateBox
                                    value={dataEmissaoInicial}
                                    colSpan={1}
                                    onValueChanged={(e) => setDataEmissaoInicial(e.value)} 
                                    width={"100%"}
                                    useMaskBehavior={true} />
                            </SimpleItem>
                            <SimpleItem
                                colSpan={2}
                                editorType={"dxTagBox"}
                                editorOptions={statusOptions}
                            >
                                <Label text="Status" />
                            </SimpleItem>
                            <SimpleItem colSpan={1}>
                                <Label text="Data de Emissão Final" />
                                <DateBox
                                    value={dataEmissaoFinal}
                                    colSpan={1}
                                    onValueChanged={(e) => setdataEmissaoFinal(e.value)}
                                    editorType={"dxDateBox"}
                                    width={"100%"}
                                    useMaskBehavior={true} />
                            </SimpleItem>
                            <SimpleItem
                                colSpan={2}
                                editorType={"dxTagBox"}
                                editorOptions={tagOptions}
                            >
                                <Label text="Tipos de Alvará" />
                            </SimpleItem>
                        </GroupItem>

                    </Form>
                    <br />
                    <div style={{ marginTop: "10px" }}>
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={120}
                                text="Imprimir"
                                type="success"
                                onClick={imprimir}
                            />
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "10px" }}>
                            <Button text="Limpar Filtro" onClick={limparFiltro} />
                        </div>
                    </div>
                </form>
                <br /> <br />
            </div>
        </React.Fragment >
    );
}

export default AlvarasEmitidos;

